import React from 'react'

import { Select } from 'antd'
import { SelectProps } from 'antd/lib/select'

type FitlerByDaysProps = SelectProps

const options = [
  {
    label: 'Last 7 Days',
    value: 7,
  },
  {
    label: 'Last 30 Days',
    value: 30,
  },
  {
    label: 'Last 60 Days',
    value: 60,
  },
  {
    label: 'Last 90 Days',
    value: 90,
  },
]

export const FitlerByDays = (props: FitlerByDaysProps) => {
  const { style, ...rest } = props

  return (
    <Select
      defaultValue="30"
      bordered={false}
      style={{ fontSize: 22, minWidth: 200, ...style }}
      showArrow
      options={options}
      {...rest}
    />
  )
}
